"use strict";
// tslint:disable
/**
 * Ranking Rules
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleTargetsInfoApi = exports.RuleTargetsInfoApiFactory = exports.RuleTargetsInfoApiFp = exports.RuleTargetsInfoApiAxiosParamCreator = exports.RuleSetsApi = exports.RuleSetsApiFactory = exports.RuleSetsApiFp = exports.RuleSetsApiAxiosParamCreator = exports.QueryRulesApi = exports.QueryRulesApiFactory = exports.QueryRulesApiFp = exports.QueryRulesApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.SnRuleTargetsConfigType = exports.RuleSetTypeEnum = exports.QueryRulesConfigModelPreviewCustomOptionsTypeEnum = exports.QueryRuleStatusEnum = exports.QueryRuleSetActionEnum = exports.DocFieldTypeEnum = exports.CustomMatchOptionTypeEnum = void 0;
const tslib_1 = require("tslib");
const globalImportUrl = tslib_1.__importStar(require("url"));
const axios_1 = tslib_1.__importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var CustomMatchOptionTypeEnum;
(function (CustomMatchOptionTypeEnum) {
    CustomMatchOptionTypeEnum["Selectbox"] = "selectbox";
})(CustomMatchOptionTypeEnum = exports.CustomMatchOptionTypeEnum || (exports.CustomMatchOptionTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var DocFieldTypeEnum;
(function (DocFieldTypeEnum) {
    DocFieldTypeEnum["String"] = "string";
    DocFieldTypeEnum["Boolean"] = "boolean";
    DocFieldTypeEnum["Text"] = "text";
    DocFieldTypeEnum["Float"] = "float";
    DocFieldTypeEnum["Int"] = "int";
})(DocFieldTypeEnum = exports.DocFieldTypeEnum || (exports.DocFieldTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var QueryRuleSetActionEnum;
(function (QueryRuleSetActionEnum) {
    QueryRuleSetActionEnum["BoostFilters"] = "boost_filters";
    QueryRuleSetActionEnum["SetPosition"] = "set_position";
    QueryRuleSetActionEnum["RelatedSearches"] = "related_searches";
    QueryRuleSetActionEnum["Banners"] = "banners";
})(QueryRuleSetActionEnum = exports.QueryRuleSetActionEnum || (exports.QueryRuleSetActionEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var QueryRuleStatusEnum;
(function (QueryRuleStatusEnum) {
    QueryRuleStatusEnum["Draft"] = "draft";
    QueryRuleStatusEnum["WaitingForApproval"] = "waiting_for_approval";
    QueryRuleStatusEnum["Live"] = "live";
})(QueryRuleStatusEnum = exports.QueryRuleStatusEnum || (exports.QueryRuleStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var QueryRulesConfigModelPreviewCustomOptionsTypeEnum;
(function (QueryRulesConfigModelPreviewCustomOptionsTypeEnum) {
    QueryRulesConfigModelPreviewCustomOptionsTypeEnum["Selectbox"] = "selectbox";
})(QueryRulesConfigModelPreviewCustomOptionsTypeEnum = exports.QueryRulesConfigModelPreviewCustomOptionsTypeEnum || (exports.QueryRulesConfigModelPreviewCustomOptionsTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var RuleSetTypeEnum;
(function (RuleSetTypeEnum) {
    RuleSetTypeEnum["Query"] = "query";
    RuleSetTypeEnum["Data"] = "data";
})(RuleSetTypeEnum = exports.RuleSetTypeEnum || (exports.RuleSetTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SnRuleTargetsConfigType;
(function (SnRuleTargetsConfigType) {
    SnRuleTargetsConfigType["QueryRules"] = "query-rules";
    SnRuleTargetsConfigType["RelatedSearches"] = "related-searches";
    SnRuleTargetsConfigType["Banners"] = "banners";
})(SnRuleTargetsConfigType = exports.SnRuleTargetsConfigType || (exports.SnRuleTargetsConfigType = {}));
/**
 * DefaultApi - axios parameter creator
 * @export
 */
exports.DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionCustomers: async (options = {}) => {
            const localVarPath = `/api/sn/customers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
exports.DefaultApiFp = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegionCustomers(options) {
            const localVarAxiosArgs = await exports.DefaultApiAxiosParamCreator(configuration).getRegionCustomers(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
exports.DefaultApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionCustomers(options) {
            return exports.DefaultApiFp(configuration).getRegionCustomers(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getRegionCustomers(options) {
        return exports.DefaultApiFp(this.configuration).getRegionCustomers(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * QueryRulesApi - axios parameter creator
 * @export
 */
exports.QueryRulesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {QueryRulesResourceModel} queryRulesResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueryRule: async (groupId, ruleSetId, queryRulesResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createQueryRule.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling createQueryRule.');
            }
            // verify required parameter 'queryRulesResourceModel' is not null or undefined
            if (queryRulesResourceModel === null || queryRulesResourceModel === undefined) {
                throw new base_1.RequiredError('queryRulesResourceModel', 'Required parameter queryRulesResourceModel was null or undefined when calling createQueryRule.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}/queryRules`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof queryRulesResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(queryRulesResourceModel !== undefined ? queryRulesResourceModel : {}) : (queryRulesResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {string} queryRuleId
         * @param {string} queryRuleStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueryRule: async (groupId, ruleSetId, queryRuleId, queryRuleStatus, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteQueryRule.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling deleteQueryRule.');
            }
            // verify required parameter 'queryRuleId' is not null or undefined
            if (queryRuleId === null || queryRuleId === undefined) {
                throw new base_1.RequiredError('queryRuleId', 'Required parameter queryRuleId was null or undefined when calling deleteQueryRule.');
            }
            // verify required parameter 'queryRuleStatus' is not null or undefined
            if (queryRuleStatus === null || queryRuleStatus === undefined) {
                throw new base_1.RequiredError('queryRuleStatus', 'Required parameter queryRuleStatus was null or undefined when calling deleteQueryRule.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}/queryRules/{queryRuleId}/status/{queryRuleStatus}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)))
                .replace(`{${"queryRuleId"}}`, encodeURIComponent(String(queryRuleId)))
                .replace(`{${"queryRuleStatus"}}`, encodeURIComponent(String(queryRuleStatus)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {string} queryRuleId
         * @param {string} queryRuleStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueryRule: async (groupId, ruleSetId, queryRuleId, queryRuleStatus, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getQueryRule.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling getQueryRule.');
            }
            // verify required parameter 'queryRuleId' is not null or undefined
            if (queryRuleId === null || queryRuleId === undefined) {
                throw new base_1.RequiredError('queryRuleId', 'Required parameter queryRuleId was null or undefined when calling getQueryRule.');
            }
            // verify required parameter 'queryRuleStatus' is not null or undefined
            if (queryRuleStatus === null || queryRuleStatus === undefined) {
                throw new base_1.RequiredError('queryRuleStatus', 'Required parameter queryRuleStatus was null or undefined when calling getQueryRule.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}/queryRules/{queryRuleId}/status/{queryRuleStatus}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)))
                .replace(`{${"queryRuleId"}}`, encodeURIComponent(String(queryRuleId)))
                .replace(`{${"queryRuleStatus"}}`, encodeURIComponent(String(queryRuleStatus)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {'live' | 'other'} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueryRules: async (groupId, ruleSetId, ruleTargetsType, limit, offset, type, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getQueryRules.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling getQueryRules.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}/queryRules`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ruleTargetsType !== undefined) {
                localVarQueryParameter['rule_targets_type'] = ruleTargetsType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueryRulesConfig: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getQueryRulesConfig.');
            }
            const localVarPath = `/api/groups/{groupId}/queryRules/config`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {QueryRulesPreviewModel} queryRulesPreviewModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewQueryRule: async (groupId, ruleSetId, queryRulesPreviewModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling previewQueryRule.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling previewQueryRule.');
            }
            // verify required parameter 'queryRulesPreviewModel' is not null or undefined
            if (queryRulesPreviewModel === null || queryRulesPreviewModel === undefined) {
                throw new base_1.RequiredError('queryRulesPreviewModel', 'Required parameter queryRulesPreviewModel was null or undefined when calling previewQueryRule.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}/queryRules/_preview`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof queryRulesPreviewModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(queryRulesPreviewModel !== undefined ? queryRulesPreviewModel : {}) : (queryRulesPreviewModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {QueryRulesConfigModel} queryRulesConfigModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQueryRulesConfig: async (groupId, queryRulesConfigModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling saveQueryRulesConfig.');
            }
            // verify required parameter 'queryRulesConfigModel' is not null or undefined
            if (queryRulesConfigModel === null || queryRulesConfigModel === undefined) {
                throw new base_1.RequiredError('queryRulesConfigModel', 'Required parameter queryRulesConfigModel was null or undefined when calling saveQueryRulesConfig.');
            }
            const localVarPath = `/api/groups/{groupId}/queryRules/config`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof queryRulesConfigModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(queryRulesConfigModel !== undefined ? queryRulesConfigModel : {}) : (queryRulesConfigModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {string} queryRuleId
         * @param {QueryRulesUpdateResourceModel} queryRulesUpdateResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueryRule: async (groupId, ruleSetId, queryRuleId, queryRulesUpdateResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateQueryRule.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling updateQueryRule.');
            }
            // verify required parameter 'queryRuleId' is not null or undefined
            if (queryRuleId === null || queryRuleId === undefined) {
                throw new base_1.RequiredError('queryRuleId', 'Required parameter queryRuleId was null or undefined when calling updateQueryRule.');
            }
            // verify required parameter 'queryRulesUpdateResourceModel' is not null or undefined
            if (queryRulesUpdateResourceModel === null || queryRulesUpdateResourceModel === undefined) {
                throw new base_1.RequiredError('queryRulesUpdateResourceModel', 'Required parameter queryRulesUpdateResourceModel was null or undefined when calling updateQueryRule.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}/queryRules/{queryRuleId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)))
                .replace(`{${"queryRuleId"}}`, encodeURIComponent(String(queryRuleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof queryRulesUpdateResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(queryRulesUpdateResourceModel !== undefined ? queryRulesUpdateResourceModel : {}) : (queryRulesUpdateResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * QueryRulesApi - functional programming interface
 * @export
 */
exports.QueryRulesApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {QueryRulesResourceModel} queryRulesResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQueryRule(groupId, ruleSetId, queryRulesResourceModel, options) {
            const localVarAxiosArgs = await exports.QueryRulesApiAxiosParamCreator(configuration).createQueryRule(groupId, ruleSetId, queryRulesResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {string} queryRuleId
         * @param {string} queryRuleStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options) {
            const localVarAxiosArgs = await exports.QueryRulesApiAxiosParamCreator(configuration).deleteQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {string} queryRuleId
         * @param {string} queryRuleStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options) {
            const localVarAxiosArgs = await exports.QueryRulesApiAxiosParamCreator(configuration).getQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {'live' | 'other'} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueryRules(groupId, ruleSetId, ruleTargetsType, limit, offset, type, options) {
            const localVarAxiosArgs = await exports.QueryRulesApiAxiosParamCreator(configuration).getQueryRules(groupId, ruleSetId, ruleTargetsType, limit, offset, type, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueryRulesConfig(groupId, options) {
            const localVarAxiosArgs = await exports.QueryRulesApiAxiosParamCreator(configuration).getQueryRulesConfig(groupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {QueryRulesPreviewModel} queryRulesPreviewModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewQueryRule(groupId, ruleSetId, queryRulesPreviewModel, options) {
            const localVarAxiosArgs = await exports.QueryRulesApiAxiosParamCreator(configuration).previewQueryRule(groupId, ruleSetId, queryRulesPreviewModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {QueryRulesConfigModel} queryRulesConfigModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveQueryRulesConfig(groupId, queryRulesConfigModel, options) {
            const localVarAxiosArgs = await exports.QueryRulesApiAxiosParamCreator(configuration).saveQueryRulesConfig(groupId, queryRulesConfigModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {string} queryRuleId
         * @param {QueryRulesUpdateResourceModel} queryRulesUpdateResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQueryRule(groupId, ruleSetId, queryRuleId, queryRulesUpdateResourceModel, options) {
            const localVarAxiosArgs = await exports.QueryRulesApiAxiosParamCreator(configuration).updateQueryRule(groupId, ruleSetId, queryRuleId, queryRulesUpdateResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * QueryRulesApi - factory interface
 * @export
 */
exports.QueryRulesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {QueryRulesResourceModel} queryRulesResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueryRule(groupId, ruleSetId, queryRulesResourceModel, options) {
            return exports.QueryRulesApiFp(configuration).createQueryRule(groupId, ruleSetId, queryRulesResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {string} queryRuleId
         * @param {string} queryRuleStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options) {
            return exports.QueryRulesApiFp(configuration).deleteQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {string} queryRuleId
         * @param {string} queryRuleStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options) {
            return exports.QueryRulesApiFp(configuration).getQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {'live' | 'other'} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueryRules(groupId, ruleSetId, ruleTargetsType, limit, offset, type, options) {
            return exports.QueryRulesApiFp(configuration).getQueryRules(groupId, ruleSetId, ruleTargetsType, limit, offset, type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueryRulesConfig(groupId, options) {
            return exports.QueryRulesApiFp(configuration).getQueryRulesConfig(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {QueryRulesPreviewModel} queryRulesPreviewModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewQueryRule(groupId, ruleSetId, queryRulesPreviewModel, options) {
            return exports.QueryRulesApiFp(configuration).previewQueryRule(groupId, ruleSetId, queryRulesPreviewModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {QueryRulesConfigModel} queryRulesConfigModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQueryRulesConfig(groupId, queryRulesConfigModel, options) {
            return exports.QueryRulesApiFp(configuration).saveQueryRulesConfig(groupId, queryRulesConfigModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {string} queryRuleId
         * @param {QueryRulesUpdateResourceModel} queryRulesUpdateResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueryRule(groupId, ruleSetId, queryRuleId, queryRulesUpdateResourceModel, options) {
            return exports.QueryRulesApiFp(configuration).updateQueryRule(groupId, ruleSetId, queryRuleId, queryRulesUpdateResourceModel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * QueryRulesApi - object-oriented interface
 * @export
 * @class QueryRulesApi
 * @extends {BaseAPI}
 */
class QueryRulesApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {QueryRulesResourceModel} queryRulesResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryRulesApi
     */
    createQueryRule(groupId, ruleSetId, queryRulesResourceModel, options) {
        return exports.QueryRulesApiFp(this.configuration).createQueryRule(groupId, ruleSetId, queryRulesResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {string} queryRuleId
     * @param {string} queryRuleStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryRulesApi
     */
    deleteQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options) {
        return exports.QueryRulesApiFp(this.configuration).deleteQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {string} queryRuleId
     * @param {string} queryRuleStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryRulesApi
     */
    getQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options) {
        return exports.QueryRulesApiFp(this.configuration).getQueryRule(groupId, ruleSetId, queryRuleId, queryRuleStatus, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'live' | 'other'} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryRulesApi
     */
    getQueryRules(groupId, ruleSetId, ruleTargetsType, limit, offset, type, options) {
        return exports.QueryRulesApiFp(this.configuration).getQueryRules(groupId, ruleSetId, ruleTargetsType, limit, offset, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryRulesApi
     */
    getQueryRulesConfig(groupId, options) {
        return exports.QueryRulesApiFp(this.configuration).getQueryRulesConfig(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {QueryRulesPreviewModel} queryRulesPreviewModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryRulesApi
     */
    previewQueryRule(groupId, ruleSetId, queryRulesPreviewModel, options) {
        return exports.QueryRulesApiFp(this.configuration).previewQueryRule(groupId, ruleSetId, queryRulesPreviewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {QueryRulesConfigModel} queryRulesConfigModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryRulesApi
     */
    saveQueryRulesConfig(groupId, queryRulesConfigModel, options) {
        return exports.QueryRulesApiFp(this.configuration).saveQueryRulesConfig(groupId, queryRulesConfigModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {string} queryRuleId
     * @param {QueryRulesUpdateResourceModel} queryRulesUpdateResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryRulesApi
     */
    updateQueryRule(groupId, ruleSetId, queryRuleId, queryRulesUpdateResourceModel, options) {
        return exports.QueryRulesApiFp(this.configuration).updateQueryRule(groupId, ruleSetId, queryRuleId, queryRulesUpdateResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.QueryRulesApi = QueryRulesApi;
/**
 * RuleSetsApi - axios parameter creator
 * @export
 */
exports.RuleSetsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {RuleSetsResourceModel} ruleSetsResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRuleSet: async (groupId, ruleSetsResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createRuleSet.');
            }
            // verify required parameter 'ruleSetsResourceModel' is not null or undefined
            if (ruleSetsResourceModel === null || ruleSetsResourceModel === undefined) {
                throw new base_1.RequiredError('ruleSetsResourceModel', 'Required parameter ruleSetsResourceModel was null or undefined when calling createRuleSet.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof ruleSetsResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(ruleSetsResourceModel !== undefined ? ruleSetsResourceModel : {}) : (ruleSetsResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleSet: async (groupId, ruleSetId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteRuleSet.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling deleteRuleSet.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSet: async (groupId, ruleSetId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRuleSet.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling getRuleSet.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSets: async (groupId, ruleTargetsType, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRuleSets.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ruleTargetsType !== undefined) {
                localVarQueryParameter['rule_targets_type'] = ruleTargetsType;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSetsFields: async (groupId, ruleSetId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRuleSetsFields.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling getRuleSetsFields.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}/_fields`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSetsTargets: async (groupId, ruleTargetsType, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRuleSetsTargets.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/_targets`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ruleTargetsType !== undefined) {
                localVarQueryParameter['rule_targets_type'] = ruleTargetsType;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {RuleSetsResourceModel} ruleSetsResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleSet: async (groupId, ruleSetId, ruleSetsResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRuleSet.');
            }
            // verify required parameter 'ruleSetId' is not null or undefined
            if (ruleSetId === null || ruleSetId === undefined) {
                throw new base_1.RequiredError('ruleSetId', 'Required parameter ruleSetId was null or undefined when calling updateRuleSet.');
            }
            // verify required parameter 'ruleSetsResourceModel' is not null or undefined
            if (ruleSetsResourceModel === null || ruleSetsResourceModel === undefined) {
                throw new base_1.RequiredError('ruleSetsResourceModel', 'Required parameter ruleSetsResourceModel was null or undefined when calling updateRuleSet.');
            }
            const localVarPath = `/api/groups/{groupId}/rulesets/{ruleSetId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"ruleSetId"}}`, encodeURIComponent(String(ruleSetId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof ruleSetsResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(ruleSetsResourceModel !== undefined ? ruleSetsResourceModel : {}) : (ruleSetsResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RuleSetsApi - functional programming interface
 * @export
 */
exports.RuleSetsApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {RuleSetsResourceModel} ruleSetsResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRuleSet(groupId, ruleSetsResourceModel, options) {
            const localVarAxiosArgs = await exports.RuleSetsApiAxiosParamCreator(configuration).createRuleSet(groupId, ruleSetsResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRuleSet(groupId, ruleSetId, options) {
            const localVarAxiosArgs = await exports.RuleSetsApiAxiosParamCreator(configuration).deleteRuleSet(groupId, ruleSetId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleSet(groupId, ruleSetId, options) {
            const localVarAxiosArgs = await exports.RuleSetsApiAxiosParamCreator(configuration).getRuleSet(groupId, ruleSetId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleSets(groupId, ruleTargetsType, options) {
            const localVarAxiosArgs = await exports.RuleSetsApiAxiosParamCreator(configuration).getRuleSets(groupId, ruleTargetsType, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleSetsFields(groupId, ruleSetId, options) {
            const localVarAxiosArgs = await exports.RuleSetsApiAxiosParamCreator(configuration).getRuleSetsFields(groupId, ruleSetId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleSetsTargets(groupId, ruleTargetsType, options) {
            const localVarAxiosArgs = await exports.RuleSetsApiAxiosParamCreator(configuration).getRuleSetsTargets(groupId, ruleTargetsType, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {RuleSetsResourceModel} ruleSetsResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRuleSet(groupId, ruleSetId, ruleSetsResourceModel, options) {
            const localVarAxiosArgs = await exports.RuleSetsApiAxiosParamCreator(configuration).updateRuleSet(groupId, ruleSetId, ruleSetsResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RuleSetsApi - factory interface
 * @export
 */
exports.RuleSetsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {RuleSetsResourceModel} ruleSetsResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRuleSet(groupId, ruleSetsResourceModel, options) {
            return exports.RuleSetsApiFp(configuration).createRuleSet(groupId, ruleSetsResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleSet(groupId, ruleSetId, options) {
            return exports.RuleSetsApiFp(configuration).deleteRuleSet(groupId, ruleSetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSet(groupId, ruleSetId, options) {
            return exports.RuleSetsApiFp(configuration).getRuleSet(groupId, ruleSetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSets(groupId, ruleTargetsType, options) {
            return exports.RuleSetsApiFp(configuration).getRuleSets(groupId, ruleTargetsType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSetsFields(groupId, ruleSetId, options) {
            return exports.RuleSetsApiFp(configuration).getRuleSetsFields(groupId, ruleSetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleSetsTargets(groupId, ruleTargetsType, options) {
            return exports.RuleSetsApiFp(configuration).getRuleSetsTargets(groupId, ruleTargetsType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} ruleSetId
         * @param {RuleSetsResourceModel} ruleSetsResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleSet(groupId, ruleSetId, ruleSetsResourceModel, options) {
            return exports.RuleSetsApiFp(configuration).updateRuleSet(groupId, ruleSetId, ruleSetsResourceModel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RuleSetsApi - object-oriented interface
 * @export
 * @class RuleSetsApi
 * @extends {BaseAPI}
 */
class RuleSetsApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} groupId
     * @param {RuleSetsResourceModel} ruleSetsResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleSetsApi
     */
    createRuleSet(groupId, ruleSetsResourceModel, options) {
        return exports.RuleSetsApiFp(this.configuration).createRuleSet(groupId, ruleSetsResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleSetsApi
     */
    deleteRuleSet(groupId, ruleSetId, options) {
        return exports.RuleSetsApiFp(this.configuration).deleteRuleSet(groupId, ruleSetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleSetsApi
     */
    getRuleSet(groupId, ruleSetId, options) {
        return exports.RuleSetsApiFp(this.configuration).getRuleSet(groupId, ruleSetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleSetsApi
     */
    getRuleSets(groupId, ruleTargetsType, options) {
        return exports.RuleSetsApiFp(this.configuration).getRuleSets(groupId, ruleTargetsType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleSetsApi
     */
    getRuleSetsFields(groupId, ruleSetId, options) {
        return exports.RuleSetsApiFp(this.configuration).getRuleSetsFields(groupId, ruleSetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleSetsApi
     */
    getRuleSetsTargets(groupId, ruleTargetsType, options) {
        return exports.RuleSetsApiFp(this.configuration).getRuleSetsTargets(groupId, ruleTargetsType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} ruleSetId
     * @param {RuleSetsResourceModel} ruleSetsResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleSetsApi
     */
    updateRuleSet(groupId, ruleSetId, ruleSetsResourceModel, options) {
        return exports.RuleSetsApiFp(this.configuration).updateRuleSet(groupId, ruleSetId, ruleSetsResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RuleSetsApi = RuleSetsApi;
/**
 * RuleTargetsInfoApi - axios parameter creator
 * @export
 */
exports.RuleTargetsInfoApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleTargetsInfo: async (groupId, inlineObject, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteRuleTargetsInfo.');
            }
            // verify required parameter 'inlineObject' is not null or undefined
            if (inlineObject === null || inlineObject === undefined) {
                throw new base_1.RequiredError('inlineObject', 'Required parameter inlineObject was null or undefined when calling deleteRuleTargetsInfo.');
            }
            const localVarPath = `/api/groups/{groupId}/sn/config`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof inlineObject !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject !== undefined ? inlineObject : {}) : (inlineObject || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleTargetsInfo: async (groupId, ruleTargetsType, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRuleTargetsInfo.');
            }
            const localVarPath = `/api/groups/{groupId}/sn/config`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ruleTargetsType !== undefined) {
                localVarQueryParameter['rule_targets_type'] = ruleTargetsType;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsModel} snRuleTargetsModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRuleTargetsInfo: async (groupId, snRuleTargetsModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling setRuleTargetsInfo.');
            }
            // verify required parameter 'snRuleTargetsModel' is not null or undefined
            if (snRuleTargetsModel === null || snRuleTargetsModel === undefined) {
                throw new base_1.RequiredError('snRuleTargetsModel', 'Required parameter snRuleTargetsModel was null or undefined when calling setRuleTargetsInfo.');
            }
            const localVarPath = `/api/groups/{groupId}/sn/config`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof snRuleTargetsModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(snRuleTargetsModel !== undefined ? snRuleTargetsModel : {}) : (snRuleTargetsModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RuleTargetsInfoApi - functional programming interface
 * @export
 */
exports.RuleTargetsInfoApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRuleTargetsInfo(groupId, inlineObject, options) {
            const localVarAxiosArgs = await exports.RuleTargetsInfoApiAxiosParamCreator(configuration).deleteRuleTargetsInfo(groupId, inlineObject, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleTargetsInfo(groupId, ruleTargetsType, options) {
            const localVarAxiosArgs = await exports.RuleTargetsInfoApiAxiosParamCreator(configuration).getRuleTargetsInfo(groupId, ruleTargetsType, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsModel} snRuleTargetsModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setRuleTargetsInfo(groupId, snRuleTargetsModel, options) {
            const localVarAxiosArgs = await exports.RuleTargetsInfoApiAxiosParamCreator(configuration).setRuleTargetsInfo(groupId, snRuleTargetsModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RuleTargetsInfoApi - factory interface
 * @export
 */
exports.RuleTargetsInfoApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRuleTargetsInfo(groupId, inlineObject, options) {
            return exports.RuleTargetsInfoApiFp(configuration).deleteRuleTargetsInfo(groupId, inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleTargetsInfo(groupId, ruleTargetsType, options) {
            return exports.RuleTargetsInfoApiFp(configuration).getRuleTargetsInfo(groupId, ruleTargetsType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {SnRuleTargetsModel} snRuleTargetsModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRuleTargetsInfo(groupId, snRuleTargetsModel, options) {
            return exports.RuleTargetsInfoApiFp(configuration).setRuleTargetsInfo(groupId, snRuleTargetsModel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RuleTargetsInfoApi - object-oriented interface
 * @export
 * @class RuleTargetsInfoApi
 * @extends {BaseAPI}
 */
class RuleTargetsInfoApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} groupId
     * @param {InlineObject} inlineObject
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleTargetsInfoApi
     */
    deleteRuleTargetsInfo(groupId, inlineObject, options) {
        return exports.RuleTargetsInfoApiFp(this.configuration).deleteRuleTargetsInfo(groupId, inlineObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {SnRuleTargetsConfigType} [ruleTargetsType] Query Rules, Related Searches, etc. have different targets. If param is missing, Query Rules targets are returned by default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleTargetsInfoApi
     */
    getRuleTargetsInfo(groupId, ruleTargetsType, options) {
        return exports.RuleTargetsInfoApiFp(this.configuration).getRuleTargetsInfo(groupId, ruleTargetsType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {SnRuleTargetsModel} snRuleTargetsModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleTargetsInfoApi
     */
    setRuleTargetsInfo(groupId, snRuleTargetsModel, options) {
        return exports.RuleTargetsInfoApiFp(this.configuration).setRuleTargetsInfo(groupId, snRuleTargetsModel, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RuleTargetsInfoApi = RuleTargetsInfoApi;
